// let baseurl='https://apidev.iserveu.online/isu/LOS/';
// let baseurl='https://txnflow.txninfra.com/isu/camunda/';
let baseurl = "https://api-prod.txninfra.com/kotak/kotak/camunda/los/";
//  let baseurl= 'https://apidev.iserveu.online/isu/LOS/';
export const ApiUrl = {
  GetFeature: `https://api-prod.txninfra.com/kotak/kotak/camunda/feature/fetchFeature`,
  StartProcess: `${baseurl}startProcessInstance`,
  FormSchema: `${baseurl}getFormSchema/`,
  CompleteTask: `${baseurl}completeTask/`,
  ElasticSearch: `${baseurl}elasticSearch/companies_master/_search`,
};
